import { Component } from '@angular/core';
import { ADBInfo, DBPanelInfo, HaufeX360DBInfo } from '../../../../../models/datamodel/adbinfo.model';
import { BaseDataSourcePanel } from '../../../../../settings/datamodel/datasource/datasourcepanels/basedatasource.panel';

@Component({
    selector: 'haufeX360-panel',
    templateUrl: './haufeX360.panel.html'
})
export class HaufeX360Panel extends BaseDataSourcePanel {

    static GetInfo(): DBPanelInfo {
        return {
            ControlType: HaufeX360Panel,
            DBInfoType: HaufeX360DBInfo
        };
    }

    constructor() {
        super();
        this.DBInfoType = HaufeX360DBInfo;
    }   
}
